import { put, call, takeLatest } from "redux-saga/effects";

import { getAPIPayload } from "../../../apis/getApi";
import { postAPIPayload } from "../../../apis/postApi";
import { communicationAction } from "../../slices/communication/communicationSlice";

export function* fetchCommunicationsSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(communicationAction.fetchCommunicationsData(response));
}

export function* fetchCommunicationDetailSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(communicationAction.fetchCommunicationDetail(response));
}

export function* resendCommunicationSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(communicationAction.fetchResendCommunication(response));
}

export function* watchCommunicationSagaAsync() {
  yield takeLatest(
    communicationAction.getCommunicationsData,
    fetchCommunicationsSaga,
  );
  yield takeLatest(
    communicationAction.getCommunicationDetail,
    fetchCommunicationDetailSaga,
  );
  yield takeLatest(
    communicationAction.resendCommunication,
    resendCommunicationSaga,
  );
}
